module.exports = __webpack_public_path__ + "img/mth.132f3005.svg";